/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * active_total object
 * @export
 * @interface GetFwLeaderboardsActiveTotalActiveTotal
 */
export interface GetFwLeaderboardsActiveTotalActiveTotal {
    /**
     * Amount of kills
     * @type {number}
     * @memberof GetFwLeaderboardsActiveTotalActiveTotal
     */
    amount?: number;
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsActiveTotalActiveTotal
     */
    factionId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsActiveTotalActiveTotal interface.
 */
export function instanceOfGetFwLeaderboardsActiveTotalActiveTotal(value: object): value is GetFwLeaderboardsActiveTotalActiveTotal {
    return true;
}

export function GetFwLeaderboardsActiveTotalActiveTotalFromJSON(json: any): GetFwLeaderboardsActiveTotalActiveTotal {
    return GetFwLeaderboardsActiveTotalActiveTotalFromJSONTyped(json, false);
}

export function GetFwLeaderboardsActiveTotalActiveTotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsActiveTotalActiveTotal {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
    };
}

export function GetFwLeaderboardsActiveTotalActiveTotalToJSON(json: any): GetFwLeaderboardsActiveTotalActiveTotal {
    return GetFwLeaderboardsActiveTotalActiveTotalToJSONTyped(json, false);
}

export function GetFwLeaderboardsActiveTotalActiveTotalToJSONTyped(value?: GetFwLeaderboardsActiveTotalActiveTotal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'faction_id': value['factionId'],
    };
}

